<template>
    <div>
        <div class="inner_container content_box withPad ">
            <div v-if="data_api" class="d-flex flex-column justify-space-between align-center">
                <v-img v-if="image" contain max-width="100%" :src="image" :lazy-src="image_lazy" style="border-radius: 15px;">
                    <template v-slot:placeholder>
                        <v-row class="fill-height ma-0" align="center" justify="center">
                            <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                        </v-row>
                    </template>
                </v-img>
            </div>
            <div class="title_cover mt-5">
                <h3>{{data_api.unique_message}}</h3>
            </div>
            
        </div><!--end.page1-->
    </div>
</template>

<script>

export default {
  name: "unique",
  data() {
    return {
      data_api: this.$parent.data.get,
      image: this.$parent.data.get.cover_image ? this.$parent.data.get.cover_image.real : null,
      image_lazy : this.$parent.data.get.cover_image ? this.$parent.data.get.cover_image.real : null,
      image_exp : this.$parent.data.get.image_exp ? this.$parent.data.get.image_exp.real : null,
      caption_exp: this.$parent.data.get.caption_exp ? this.$parent.data.get.caption_exp : 'Maaf, Periode kuis telah berakhir tungguin ya keseruan lainnya di kuis berikutnya',      
    };
  },
  created()
  {
      this.viewTracker('cover');
      this.$parent.updateHead();
  }
  
};
</script>
